import React from 'react';
import FAQ from '@/components/landing/pricing/FAQ';
import { PRODUCT_FAQS } from '@/lib/faqs';

interface ProductFAQProps {
  slug: string;
}

/**
 * Renders the shared FAQ accordion with the product's own Q&As, plus
 * FAQPage structured data for the page.
 */
const ProductFAQ: React.FC<ProductFAQProps> = ({ slug }) => {
  const faqs = PRODUCT_FAQS[slug];
  if (!faqs || faqs.length === 0) return null;

  return <FAQ faqs={faqs} schema />;
};

export default ProductFAQ;
